import React from 'react'
import PropTypes from 'prop-types'
import Container from '@material-ui/core/Container'
import { makeStyles } from '@material-ui/core/styles'

// Components
import SEO from '../../components/seo'
import Hero from '../../components/hero'
import NewsletterPrimary from '../../components/newsletterPrimary'
import ProductReviews from '../../components/stampedReviews/productReviews'

// Strings
import strings from './strings'

// Styles
const useStyles = makeStyles((theme) => ({
  hero: {
    '& .productRating': {
      justifyContent: 'start',
    },
    '& .star, & .number': {
      color: 'white',
    },
  },
  productReviews: {
    padding: theme.spacing(5, 0),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(10, 0),
    },
    '& .subheader': {
      display: 'none',
    },
    '& .title': {
      opacity: 0,
    },
  },
}))

const ReviewsPage = (props) => {
  // console.log('REVIEWS PAGE (template)', props)
  const classes = useStyles(props)

  const { hero } = props.data.prismicReviews.data
  const reviews = props.data.allStampedProductReview.nodes

  return (
    <>
      <SEO title={strings.seoTitle} />

      <Hero styles={classes.hero} {...hero[0]} reviews={reviews} />
      <Container maxWidth="lg">
        {reviews && reviews.length > 0 && (
          <ProductReviews styles={classes.productReviews} reviews={reviews} numberPerLoad={4} />
        )}
      </Container>
      <Container maxWidth="lg">
        <NewsletterPrimary
          location="reviewsPage"
          listId={process.env.GATSBY_KLAVIYO_GENERAL_LIST}
        />
      </Container>
    </>
  )
}

export default ReviewsPage

ReviewsPage.propTypes = {}
ReviewsPage.defaultProps = {}
